import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgFavouriteEmpty = function SvgFavouriteEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "favourite-empty_svg__icon favourite-empty_svg__icon--favourite-empty"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22.275c-.2 0-.4-.1-.5-.2l-9.584-10c-1.997-2-2.496-5-1.198-7.5.898-1.8 2.696-3.1 4.692-3.5 1.997-.3 4.094.3 5.592 1.8l.998 1 .998-1c1.498-1.5 3.495-2.1 5.592-1.8 1.996.3 3.794 1.6 4.692 3.5 1.298 2.5.799 5.5-1.198 7.5l-9.585 10c-.1.1-.3.2-.499.2Zm-5.591-19.7c-.3 0-.5 0-.799.1-1.498.2-2.895 1.2-3.594 2.6-.999 1.9-.6 4.2.898 5.7l9.086 9.4 8.986-9.4c1.497-1.5 1.897-3.8.898-5.7-.698-1.4-2.096-2.4-3.594-2.7-1.597-.3-3.195.3-4.293 1.4l-1.598 1.6c-.3.3-.798.3-1.098 0l-1.398-1.6c-.898-.9-2.196-1.4-3.494-1.4Z"
  })));
};

export { SvgFavouriteEmpty as default };
//# sourceMappingURL=favourite-empty.svg.js.map
